import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import SidebarLink from './SidebarLink';
import SidebarCategory from './SidebarCategory';
import { connect } from 'react-redux';
import { withOktaAuth } from '@okta/okta-react';
import { setUserProfile } from '../../../redux/actions/authActions';
import { Publisher } from "./../../../shared/pubsub/publisher.js";
import {
	BrowserView,
	MobileView,
	isBrowser,
	isMobile,
	isTablet
} from "react-device-detect";
import { _hasPermission } from "./../../../shared/helpers/access";

import {
	_doSSOLogout,
	_setSSOToken,
	_getSSOToken,
	_getSSOOrg
} from './../../../shared/components/auth/sso/ssoutils';

class SidebarContent extends Component {
	static propTypes = {
		changeToDark: PropTypes.func.isRequired,
		changeToLight: PropTypes.func.isRequired,
		onClick: PropTypes.func.isRequired,
	};

	constructor(props) {
		super(props);
		this.state = { authenticated: null };
		this.logout = this.logout.bind(this);
	}

	hideSidebar = () => {
		const { onClick } = this.props;
		onClick();
	};

	async logout() {
		const { authState, authService, dispatch, user, dataSet } = this.props;
		const ssoToken = _getSSOToken();

		if (user.authType === "sso") {
			_doSSOLogout(this.props, setUserProfile);

		} else if (ssoToken) {
			_doSSOLogout(this.props, setUserProfile);
		}

	}

	sideRoleContent = (user) => {
		if (!user) return null;
		if (!user.accountType) user.accountType = 'buyer';
		console.log(user, user.role.filter(role => role == "broker").length)
		if (user.role.filter(role => role == "broker").length > 0) {
			console.log("here")
			return (
				<Fragment>
					<ul className="sidebar__block sidebar__bold">
						<SidebarCategory title="My Dashboard" icon="heart" collapse>
							<SidebarLink title="Overview" route="/dashboard" onClick={this.hideSidebar} />
							<SidebarLink title="News" route="/news" onClick={this.hideSidebar} />
							<SidebarLink title="Saved" route="/my-buildings" onClick={this.hideSidebar} />

							<SidebarLink title="Shared" route="/my-shared" onClick={this.hideSidebar} />
							{/* <SidebarLink title="Collections"  route="/collections" onClick={this.hideSidebar} /> */}
							<SidebarLink title="Downloads" route="/my-exports" onClick={this.hideSidebar} />

						</SidebarCategory>
					</ul>


					{/*<ul className="sidebar__block">
						  <SidebarLink title="Transaction Center" icon="cart" route="/transaction-center" onClick={this.hideSidebar} />
						  <SidebarLink title="Community Center" icon="bubble" route="/community-center" onClick={this.hideSidebar} />
					  </ul>*/}

					<ul className="sidebar__block sidebar__bold">

						{!isMobile ?

							<SidebarCategory title="Marketing Center" newLink icon="volume-high" collapse>
								<SidebarLink title="CMA/Comp Reports" route="/marketing-center/reports/comp-report" onClick={this.hideSidebar} />
								{/* RENTAL-COMP-HOLD: hidden from the menu — the report is not workable yet. The route
								    and report code are intact, so restoring this line brings it back. */}
								<SidebarLink title="Building Reports" route="/marketing-center/reports/building-report" onClick={this.hideSidebar} />
								<SidebarLink title="Listing Desc" route="/marketing-center/reports/listing-desc" isNew onClick={this.hideSidebar} />
								<hr className="sidebar__sub__sep" />
								<SidebarLink title="Market Reports" route="/marketing-center/reports" onClick={this.hideSidebar} />

								<SidebarLink title="Social Content" route="/marketing-center/social" onClick={this.hideSidebar} />
								<SidebarLink title="Email Templates" route="/marketing-center/email" onClick={this.hideSidebar} />



								{_hasPermission(user, 'mc-post-cards') && <SidebarLink title="Post Cards" route="/marketing-center/postcards" onClick={this.hideSidebar} />}
								<SidebarLink title="Owner Outreach" route="/owner-outreach" nClick={this.hideSidebar} />
								<hr className="sidebar__sub__sep" />
								<SidebarLink title="Coming Soon Email" route="/marketing-center/reports/coming-soon-email" onClick={this.hideSidebar} />
								{_hasPermission(user, 'broker-outreach') && <SidebarLink title="Broker Outreach" route="/broker-outreach" isNew onClick={this.hideSidebar} />}

								{_hasPermission(user, 'mc-video') && <SidebarLink title="Videos" route="/marketing-center/video" beta onClick={this.hideSidebar} />}
							</SidebarCategory>

							: null}
						<SidebarCategory title="Properties" newLink icon="apartment" collapse>
							<SidebarLink title="Buildings" route="/buildings/condos" onClick={this.hideSidebar} />
							<SidebarLink title="Houses" route="/building-database/house" onClick={this.hideSidebar} />
							<SidebarLink title="Inventory (Units)" route="/inventory" onClick={this.hideSidebar} />
							<SidebarLink title="Map Search" route="/map" onClick={this.hideSidebar} />
							<SidebarLink title="Foreclosures" route="/foreclosure-search" isNew onClick={this.hideSidebar} />
						</SidebarCategory>
						<SidebarCategory title="Analysis Tools" newLink icon="chart-bars" collapse>
							<SidebarLink title="Market Activity" route="/analysis/market-pulse" onClick={this.hideSidebar} />
							<SidebarLink title="Past Sales" upgrade={!_hasPermission(user, 'past-sales')} route="/past-sales" onClick={this.hideSidebar} />

						</SidebarCategory>


					</ul>



				</Fragment>
			)
		} else if (!_hasPermission(user, 'sponsor-buildings')) {
			return (
				<Fragment>
					<ul className="sidebar__block sidebar__bold">
						<SidebarCategory title="My Dashboard" icon="heart" collapse>
							<SidebarLink title="Overview" route="/dashboard" onClick={this.hideSidebar} />
							{!isMobile ? <SidebarLink title="Market Snapshots" route="/analysis/market-snapshots" onClick={this.hideSidebar} /> : null}
							{/*!isMobile ?	<SidebarLink title="Marketing Center" route="/marketing-center" isNew onClick={this.hideSidebar} /> : null*/}
							<SidebarLink title="News" route="/news" onClick={this.hideSidebar} />
							<SidebarLink title="Saved" route="/my-buildings" onClick={this.hideSidebar} />

							<SidebarLink title="Shared" route="/my-shared" onClick={this.hideSidebar} />
							<SidebarLink title="Collections" route="/collections" onClick={this.hideSidebar} />
							<SidebarLink title="Downloads" route="/my-exports" onClick={this.hideSidebar} />


						</SidebarCategory>
					</ul>


					{/*<ul className="sidebar__block">
						  <SidebarLink title="Transaction Center" icon="cart" route="/transaction-center" onClick={this.hideSidebar} />
						  <SidebarLink title="Community Center" icon="bubble" route="/community-center" onClick={this.hideSidebar} />
					  </ul>*/}
					{isMobile ?
						<Fragment>
							<ul className="sidebar__block sidebar__bold">
								<SidebarLink title="Search Inventory" icon="apartment" route="/inventory" onClick={this.hideSidebar} />
								<SidebarLink title="Search Buildings" icon="apartment" route="/buildings/condos" onClick={this.hideSidebar} />
								<SidebarLink title="Search Houses" icon="home" route="/building-database/house" onClick={this.hideSidebar} />
							</ul>
						</Fragment>
						:
						<ul className="sidebar__block sidebar__bold">
							<SidebarCategory title="Marketing Center" newLink icon="volume-high" collapse>
								<SidebarLink title="CMA/Comp Report" route="/marketing-center/reports/comp-report" onClick={this.hideSidebar} />
								{/* RENTAL-COMP-HOLD: hidden from the menu — the report is not workable yet. The route
								    and report code are intact, so restoring this line brings it back. */}
								<SidebarLink title="Building Report" route="/marketing-center/reports/building-report" onClick={this.hideSidebar} />
								<SidebarLink title="Listing Desc" route="/marketing-center/reports/listing-desc" isNew onClick={this.hideSidebar} />
								<hr className="sidebar__sub__sep" />
								<SidebarLink title="Market Reports" route="/marketing-center/reports" onClick={this.hideSidebar} />

								<SidebarLink title="Social Content" route="/marketing-center/social" onClick={this.hideSidebar} />
								<SidebarLink title="Email Templates" route="/marketing-center/email" onClick={this.hideSidebar} />



								<hr className="sidebar__sub__sep" />
								{_hasPermission(user, 'mc-post-cards') && <SidebarLink title="Post Cards" route="/marketing-center/postcards" onClick={this.hideSidebar} />}
								<SidebarLink title="Owner Outreach" route="/owner-outreach" nClick={this.hideSidebar} />
								<hr className="sidebar__sub__sep" />
								<SidebarLink title="Coming Soon Email" route="/marketing-center/reports/coming-soon-email" onClick={this.hideSidebar} />
								{_hasPermission(user, 'broker-outreach') && <SidebarLink title="Broker Outreach" route="/broker-outreach" isNew onClick={this.hideSidebar} />}

								{_hasPermission(user, 'mc-video') && <SidebarLink title="Video" route="/marketing-center/video" beta onClick={this.hideSidebar} />}
							</SidebarCategory>
							<SidebarCategory title="Properties" newLink icon="apartment" collapse>
								<SidebarLink title="Buildings" route="/buildings/condos" onClick={this.hideSidebar} />
								<SidebarLink title="Houses" route="/building-database/house" onClick={this.hideSidebar} />
								<SidebarLink title="Inventory (Units)" route="/inventory" onClick={this.hideSidebar} />
								<SidebarLink title="Map Search" route="/map" onClick={this.hideSidebar} />
								<SidebarLink title="Foreclosures" route="/foreclosure-search" isNew onClick={this.hideSidebar} />
							</SidebarCategory>


							<SidebarCategory title="Research" newLink icon="chart-bars" collapse>
								<SidebarLink title="Market Activity" route="/analysis/market-pulse" onClick={this.hideSidebar} />
								<SidebarLink title="Price Trends" upgrade={!_hasPermission(user, 'price-trends')} route="/analysis/pricing" onClick={this.hideSidebar} />
								<SidebarLink title="Discount Analysis" upgrade={!_hasPermission(user, 'discount-analysis')} route="/analysis/discount" onClick={this.hideSidebar} />

								<SidebarLink title="Past Sales" upgrade={!_hasPermission(user, 'past-sales')} route="/past-sales" onClick={this.hideSidebar} />
							</SidebarCategory>

							{_hasPermission(user, 'admin-tools') &&
								<SidebarCategory title="Admin Tools" icon="lock" collapse>
									<SidebarLink title="Coming Soon" route="/coming-soon" onClick={this.hideSidebar} />																    </SidebarCategory>
							}
						</ul>


					}

				</Fragment>
			)
		} else {

			return (
				<Fragment>
					<ul className="sidebar__block sidebar__bold">
						<SidebarCategory title="My Dashboard" icon="heart" collapse>
							<SidebarLink title="Overview" route="/dashboard" onClick={this.hideSidebar} />
							{!isMobile ? <SidebarLink title="Market Snapshots" route="/analysis/market-snapshots" onClick={this.hideSidebar} /> : null}
							{/*!isMobile ?	<SidebarLink title="Marketing Center" route="/marketing-center" isNew onClick={this.hideSidebar} /> : null*/}
							<SidebarLink title="News" route="/news" onClick={this.hideSidebar} />
							<SidebarLink title="Saved" route="/my-buildings" onClick={this.hideSidebar} />

							<SidebarLink title="Shared" route="/my-shared" onClick={this.hideSidebar} />
							<SidebarLink title="Collections" route="/collections" onClick={this.hideSidebar} />
							<SidebarLink title="Downloads" route="/my-exports" onClick={this.hideSidebar} />


						</SidebarCategory>
					</ul>
					{!isMobile ?
						<ul className="sidebar__block sidebar__bold">

							<SidebarCategory title="Marketing Center" newLink icon="volume-high" collapse>
								<SidebarLink title="CMA/Comp Reports" route="/marketing-center/reports/comp-report" onClick={this.hideSidebar} />
								{/* RENTAL-COMP-HOLD: hidden from the menu — the report is not workable yet. The route
								    and report code are intact, so restoring this line brings it back. */}
								<SidebarLink title="Building Reports" route="/marketing-center/reports/building-report" onClick={this.hideSidebar} />
								<SidebarLink title="Listing Desc" route="/marketing-center/reports/listing-desc" onClick={this.hideSidebar} />
								<hr className="sidebar__sub__sep" />
								<SidebarLink title="Market Reports" route="/marketing-center/reports" onClick={this.hideSidebar} />

								<SidebarLink title="Social Content" route="/marketing-center/social" onClick={this.hideSidebar} />
								<SidebarLink title="Email Templates" route="/marketing-center/email" onClick={this.hideSidebar} />



								{_hasPermission(user, 'mc-post-cards') && <SidebarLink title="Post Cards" route="/marketing-center/postcards" onClick={this.hideSidebar} />}
								{/* <SidebarLink title="Owner Outreach" route="/owner-outreach" isNew nClick={this.hideSidebar} /> */}
								<SidebarLink title="Coming Soon Email" route="/marketing-center/reports/coming-soon-email" onClick={this.hideSidebar} />
								{/* {_hasPermission(user, 'broker-outreach') && <SidebarLink title="Broker Outreach" route="/broker-outreach" isNew onClick={this.hideSidebar} /> } */}

								{_hasPermission(user, 'mc-video') && <SidebarLink title="Videos" route="/marketing-center/video" beta onClick={this.hideSidebar} />}
							</SidebarCategory>
							<SidebarCategory title="Outreach" newLink icon="rocket" collapse>
								<SidebarLink title="Owner Outreach" route="/owner-outreach" nClick={this.hideSidebar} />
								<SidebarLink title="Expired Listings" route="/expired-listings" onClick={this.hideSidebar} />
								{_hasPermission(user, 'skip-trace') && <SidebarLink title="My Owners" route="/my-owners" nClick={this.hideSidebar} />}
								<hr className="sidebar__sub__sep" />

								<SidebarLink title="Broker Outreach" route="/broker-outreach" nClick={this.hideSidebar} />


							</SidebarCategory>

						</ul>
						: null}

					{/*<ul className="sidebar__block">
							<SidebarLink title="Transaction Center" icon="cart" route="/transaction-center" onClick={this.hideSidebar} />
							<SidebarLink title="Community Center" icon="bubble" route="/community-center" onClick={this.hideSidebar} />
						</ul>*/}
					{isMobile ?
						<Fragment>
							<ul className="sidebar__block sidebar__bold">
								<SidebarLink title="Search Inventory" icon="apartment" route="/inventory" onClick={this.hideSidebar} />
								<SidebarLink title="Search Buildings" icon="apartment" route="/buildings/condos" onClick={this.hideSidebar} />
								<SidebarLink title="Search Houses" icon="home" route="/building-database/house" onClick={this.hideSidebar} />
							</ul>
						</Fragment>
						:
						<ul className="sidebar__block sidebar__bold">
							<SidebarCategory title="Properties" newLink icon="apartment" collapse>
								<SidebarLink title="Buildings" route="/buildings/condos" onClick={this.hideSidebar} />
								<SidebarLink title="Houses" route="/building-database/house" onClick={this.hideSidebar} />
								<SidebarLink title="Inventory (Units)" route="/inventory" onClick={this.hideSidebar} />
								<SidebarLink title="Map Search" route="/map" onClick={this.hideSidebar} />
								<SidebarLink title="Foreclosures" route="/foreclosure-search" isNew onClick={this.hideSidebar} />
							</SidebarCategory>

							<SidebarCategory title="Research" icon="chart-bars" collapse>
								<SidebarLink title="Market Activity" route="/analysis/market-pulse" onClick={this.hideSidebar} />


								<SidebarLink title="Price Trends" upgrade={!_hasPermission(user, 'price-trends')} route="/analysis/pricing" onClick={this.hideSidebar} />
								<SidebarLink title="Discount Analysis" upgrade={!_hasPermission(user, 'discount-analysis')} route="/analysis/discount" onClick={this.hideSidebar} />

								<SidebarLink title="Past Sales" upgrade={!_hasPermission(user, 'past-sales')} route="/past-sales" onClick={this.hideSidebar} />
							</SidebarCategory>
							<SidebarCategory title="New Dev Tools" newLink icon="pie-chart" collapse>
								<SidebarLink title="Sales Velocity" upgrade={!_hasPermission(user, 'sales-velocity')} route="/analysis/sales-velocity" onClick={this.hideSidebar} />
								<SidebarLink title="Inventory Analysis" route="/inventory-analysis" onClick={this.hideSidebar} />

								{/*<SidebarLink title="Condos & Co-ops" route="/building-database/sale" onClick={this.hideSidebar} />*/}
								<SidebarLink title="Permits & Filings" upgrade={!_hasPermission(user, 'pipeline')} route="/filings" onClick={this.hideSidebar} />
								<SidebarLink title="Sales Agents" upgrade={!_hasPermission(user, 'sales-agents')} route="/sales-agents" onClick={this.hideSidebar} />
								<SidebarLink title="Developers" upgrade={!_hasPermission(user, 'developers')} route="/developers" onClick={this.hideSidebar} />
								<SidebarLink title="Architects" upgrade={!_hasPermission(user, 'architects')} route="/architects" onClick={this.hideSidebar} />
								<SidebarLink title="Lenders" upgrade={!_hasPermission(user, 'lenders')} route="/lenders" onClick={this.hideSidebar} />


							</SidebarCategory>
							{/*_hasPermission(user, 'admin-tools') &&
						        	<SidebarCategory title="Admin Tools" icon="lock" collapse>						        
							        	<SidebarLink title="Coming Soon" route="/coming-soon" onClick={this.hideSidebar} />																    </SidebarCategory>
						     	*/}
						</ul>


					}

				</Fragment>
			)
		}

	}

	render() {
		const { changeToDark, changeToLight, user } = this.props;
		const ssoOrg = _getSSOOrg();
		return (
			<div className="sidebar__content">
				{this.sideRoleContent(user)}



				<ul className="sidebar__block">
					{/*<SidebarCategory title="Settings" icon="cog">
            <button type="button" className="sidebar__link" onClick={changeToLight}>
              <p className="sidebar__link-title">Light Mode</p>
            </button>
            <button type="button" className="sidebar__link" onClick={changeToDark}>
              <p className="sidebar__link-title">Dark Mode</p>
            </button>
          </SidebarCategory>*/}
					{/*<SidebarLink title="Log Out" icon="exit" onClick={this.logout} />
          <SidebarLink title="My Account" icon="user" route="/my-account"  onClick={this.hideSidebar} />*/}
					<SidebarCategory title="My Account" icon="user">
						<SidebarLink title="Update Profile" route="/my-account/profile" onClick={this.hideSidebar} />
						<SidebarLink title="Subscription & Billing" route="/my-subscription" onClick={this.hideSidebar} />
						{(!(user && user.authType && user.authType == "sso") || ssoOrg == "MPSSO") ?
							<SidebarLink title="Change Password" route="/my-account/password" onClick={this.hideSidebar} />
							: null
						}
					</SidebarCategory>

					<li className="sidebar__link" onClick={this.logout}>
						<span className={`sidebar__link-icon lnr lnr-exit`} />
						<p className="sidebar__link-title">
							Log Out
						</p>
					</li>

					{isMobile &&
						<div style={{ margin: 10, padding: '10px 30px', background: '#fafbfe', fontSize: '11px' }}>
							For access to all tools,<br /> use the desktop version.
						</div>
					}
				</ul>
			</div>
		);
	}
}

export default connect(state => ({
	user: state.user,
}))(withOktaAuth(SidebarContent));
